import React from "react"
import { useProductCard } from "../../hooks/useProductCard"
import { Prices } from "../../../ui-shared/components/Prices"
import { productCardPrices } from "./ProductCard.css"
import { useUSJourney } from "packages/acquisition/hooks/useUSJourney"

export const ProductCardPrices: React.FC = () => {
  const { productCardData } = useProductCard()
  const isUSJourney = useUSJourney()

  if (isUSJourney) {
    return null
  }

  return (
    <div className={productCardPrices}>
      <Prices
        primaryPrice={productCardData.primaryPrice}
        primarySubtitle={productCardData.primarySubtitle}
        secondaryPrice={productCardData.secondaryPrice}
        secondarySubtitle={productCardData.secondarySubtitle}
        highlightedPrice={productCardData.highlightedPrice}
      />
    </div>
  )
}
